define([], function() {
  'use strict';
  return {
    assets: {
      icon: '/v1.0/Item/{item_id}/icon/{shelf_type}/web/{status}.png',
      audio: '/v1.0/Item/{item_id}/audio/{shelf_type}/web/{item_id}.mp3'
    }
  };
});
